import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Card from '@components/Card/Card';
import urls from '@routes/urls';

const InquiriesAdminCard: FC = () => {
  const { t } = useTranslation();

  return (
    <Card
      icon="/images/img-inquirystatus-circle.svg"
      title={t('dashboardCards.inquiriesAdmin.title')}
      link={{
        title: t('dashboardCards.inquiriesAdmin.linkTitle'),
        routerLink: urls.adminInquiries,
      }}
    />
  );
};

export default InquiriesAdminCard;
